import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ChangePasswordComponent } from './change-password';

export const ChangePasswordModule: string = ng
    .module('archiSmall.userSettings.changePasswordModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('changePasswordComponent', ChangePasswordComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/change-password/change-password.module.ts